var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex h-screen"},[_c('Left',{ref:"leftComponent"}),_c('Chat',{ref:"chatComponent",on:{"favorite-count-changed":_vm.onFavoriteCountChanged,"conversation-saved":_vm.onConversationSaved}}),_c('Right',{on:{"question-clicked":_vm.onQuestionClicked,"export-chat-history":_vm.onExportChatHistory,"share-chat":_vm.onShareChat}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }